// src/components/Footer.jsx
import React from "react";
import { Link } from "react-router-dom";

/**
 * Global footer for Greenland Portal
 * - Appears on all main app pages (inside Layout)
 * - Shows compact MSRB/NFA-aware disclaimer
 * - Provides links to legal pages
 */
export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="border-t border-app bg-app text-app">
      <div className="mx-auto max-w-7xl px-4 py-3">
        {/* Disclaimer (short) */}
        <p className="text-xs leading-relaxed text-muted">
          Disclaimer: Market data is not real-time. Information on this site is
          provided for institutional users and informational purposes only and
          should not be relied upon for trading, investment, accounting or tax
          decisions, nor does it constitute a recommendation, solicitation, or
          advisory relationship. The provider of the information presented here
          does not guarantee its accuracy, completeness or timeliness.
          Forward-looking statements involve risks and uncertainties and results
          may differ.
        </p>

        {/* Divider */}
        <div className="mt-4 h-px w-full bg-border/60" />

        {/* Bottom row */}
        <div className="mt-4 flex flex-col items-start justify-between gap-2 sm:flex-row">
          <div className="text-xs text-muted">
            ©{year} Core2tek LLC. All rights reserved.
          </div>
          <nav className="flex flex-wrap items-center gap-4 text-xs">
            <Link to="/terms" className="linkCls">
              Terms of Service
            </Link>
            <Link to="/kb/support" className="linkCls">
              Contact Us
            </Link>
          </nav>
        </div>
      </div>
    </footer>
  );
}
